/* eslint-disable no-sequences */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import uniqBy from 'lodash/uniqBy';
import { RootState } from '..';
import { ResourceFilter, TableOptions } from '../../components/common/table/types';
import { TicketDTO } from '../../shared/entities/ticket';
import ActionCreator from '../action-creator';

export interface TicketsResponse {
  response: {
    totalPages: number;
    totalTickets: number;
    tickets: TicketDTO[];
  };
}

export const ActionCreators = {
  FetchTicketsPending: new ActionCreator<'FetchTicketPending', undefined, { options: TableOptions }>(
    'FetchTicketPending',
  ),
  FetchTicketsFulfilled: new ActionCreator<'FetchTicketFulfilled', TicketsResponse, { options: TableOptions }>(
    'FetchTicketFulfilled',
  ),
  FetchTicketsCanceled: new ActionCreator<'FetchTicketCanceled', undefined, { options: TableOptions }>(
    'FetchTicketCanceled',
  ),
  FetchTicketsRejected: new ActionCreator<'FetchTicketRejected', Error, { options: TableOptions }>(
    'FetchTicketRejected',
  ),
};
export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function fetchTickets(nextOptions?: Partial<TableOptions> | null) {
  return (dispatch: any) => {
    dispatch(ActionCreators.FetchTicketsPending.create(undefined, { options: nextOptions as TableOptions }));
  };
}

export function toggleTicketsFilter(filter: ResourceFilter) {
  return (dispatch: any, getState: () => RootState) => {
    const oldFilters = get(getState(), 'tickets.options.filters', []).slice();
    const filterExistedIndex = oldFilters.findIndex((oldFilter: ResourceFilter) => {
      return isEqual(oldFilter, filter);
    });

    if (filterExistedIndex >= 0) {
      oldFilters.splice(filterExistedIndex, 1);
      dispatch(fetchTickets({ page: 0, filters: oldFilters }));
    } else {
      const filters = uniqBy([filter, ...oldFilters], 'key').reverse();
      dispatch(fetchTickets({ page: 0, filters }));
    }
  };
}
